/**
 * This is a object type that extends the Typescript Map, but forces the key to be a string so the Map can be converted to
 * a generic Object and used with Reactive Forms.  Since Map allows objects as keys, we wanted a Map version with only strings
 * as keys
 */
export class MapEntry extends Map<string, any> {

  toJSON() {
    const obj: any = {};
    for (let [k, v] of this) {
      obj[k] = v;
    }
    return JSON.parse(JSON.stringify(obj));
  }
}
